import {useState} from 'react';
import {AuthForm} from '../components/auth-form';
import {login} from '../services/auth';
import {useSnackbar} from '../hooks/use-snackbar';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const {snackbar, showError, hideSnackbar} = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      window.location.href = '/dashboard';
    } catch (err) {
      showError(err.message);
    }
  };

  const fields = [
    {
      id: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'Enter your email',
      value: email,
      onChange: (e) => setEmail(e.target.value)
    },
    {
      id: 'password',
      label: 'Password',
      type: 'password',
      placeholder: 'Enter your password',
      value: password,
      onChange: (e) => setPassword(e.target.value),
      helperText: 'Must be at least 8 characters with uppercase, lowercase, number, and special character (!@#$%^&*)'
    }
  ];

  return (
    <AuthForm
      title="Sign In"
      fields={fields}
      onSubmit={handleSubmit}
      submitText="Sign In"
      footerText="Don't have an account?"
      footerLink="/register"
      footerLinkText="Sign up"
      snackbar={snackbar}
      hideSnackbar={hideSnackbar}
    />
  );
};

export default Login;